import { render, staticRenderFns } from "./lrImg.vue?vue&type=template&id=756d8f88&"
import script from "./lrImg.vue?vue&type=script&lang=js&"
export * from "./lrImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports